<template>
	<v-app v-show="app_initialized" :class="`k-app-embedded-${embedded_mode} k-app-cureum_standards_tabbed-${cureum_standards_tabbed}`">
		<AtomSkipToContentButton />
		<div v-if="site_config.agency_img_index_page_html&&(!framework_list_component||!framework_list_component.case_tree_lsdoc_identifier)&&!is_resource_route&&(!embedded_mode&&!cureum_standards_tabbed)" class="k-toolbar-agency-framework-not-showing" v-html="site_config.agency_img_index_page_html"></div>
		<v-app-bar v-if="!embedded_mode&&!cureum_standards_tabbed" app class="k-app-toolbar k-banner-color" height="60" role="banner">
			<button
				v-if="show_app_name_with_logo!='false'"
				type="button"
				class="k-toolbar-app-title k-app-title-color k-reset-button k-toolbar-home-link"
				:aria-label="`Go to ${app_name} home`"
				translate="no"
				@click="go_to_route('')"
			>
				<span v-visible="agency_logo_img_src" class="k-toolbar-agency-img-outer" aria-hidden="true">
					<img alt="" class="k-toolbar-agency-img" :src="agency_logo_img_src">
				</span>
				{{app_name_for_banner}}
			</button>
			<button
				v-else-if="agency_logo_img_src"
				type="button"
				class="k-toolbar-agency-img-outer k-reset-button k-toolbar-home-link"
				:aria-label="`Go to ${app_name} home`"
				@click="go_to_route('')"
			><img :alt="`${app_name} logo`" class="k-toolbar-agency-img" :src="agency_logo_img_src"></button>
			<button
				v-if="show_index_agency_title_button"
				type="button"
				class="k-toolbar-index-agency-title k-banner-color k-agency-color k-reset-button"
				:aria-label="open_agency_label"
				v-html="site_config.agency_name_for_banner||site_config.agency_name"
				@click="open_agency_url"
			></button>
			<k-spacer />

			<!-- google translate element is rendered here -->
			<div v-show="translate_widget_should_show && $store.state.lst.viewer_mode === 'tree'" class="d-flex align-center mr-3" :style="(gt_enabled&&!$vuetify.breakpoint.xs&&!$vuetify.breakpoint.sm)?'opacity:1':'opacity:0'">
				<div id="google_translate_element_wrapper"><div id="google_translate_element"></div></div>
				<k-btn v-if="gt_restore_btn_available" x-small outlined class="ml-1 k-tight-btn" color="#fff" @click.stop="restore_to_original_language">Restore To Original</k-btn>
			</div>

			<div v-show="app_initialized" style="display:flex;align-items:center;">
				<k-btn v-show="open_mirrors_in_satchel&&!$vuetify.breakpoint.xs&&!$vuetify.breakpoint.sm" ref="help_icon" icon color="light-blue accent-2" class="k-app-help-icon mr-3" :aria-label="`${app_name} help`" @click="toggle_help"><k-icon large>fas fa-circle-info</k-icon></k-btn>
				<div v-if="signed_in" class="k-signed-in-as" v-show="!$vuetify.breakpoint.xs&&!$vuetify.breakpoint.sm" :style="{color: U.get_contrast_color(site_config.banner_color)}">Signed in as <b>{{user_info.first_name}} {{user_info.last_name}}</b></div>
				<div v-else v-show="!$vuetify.breakpoint.xs&&!$vuetify.breakpoint.sm" :style="{color: U.get_contrast_color(site_config.banner_color)}"><k-btn small @click="sign_in">Sign In</k-btn></div>

				<k-menu v-model="nav_menu_open" accessible-popover accessible-label="Navigation menu" content-id="nav-bar-menu-panel" :transition="false" bottom offset-y left z-index="1002"><template v-slot:activator="{on, attrs}"><k-btn id="nav-bar-menu-button" v-on="on" v-bind="attrs" icon color="#fff" class="ml-3" aria-label="Open navigation menu"><k-icon :style="{color: U.get_contrast_color(site_config.banner_color)}">fas fa-bars</k-icon></k-btn></template>
					<k-list id="nav-bar-menu-panel" dense min-width="200" class="pb-0" tabindex="-1" aria-label="Navigation menu">
						<k-list-item v-show="$vuetify.breakpoint.xs||$vuetify.breakpoint.sm" tag="button" type="button" class="k-nav-menu-item" @click="toggle_help"><k-list-item-icon><k-icon small color="light-blue accent-4">fas fa-circle-info</k-icon></k-list-item-icon><k-list-item-title class="light-blue--text text--accent-4">{{app_name}} Help</k-list-item-title></k-list-item>

						<div v-if="show_resources_toggle" v-show="!($vuetify.breakpoint.xs||$vuetify.breakpoint.sm)" class="k-nav-menu-section">
							<div class="text-center" role="group" aria-label="View content type">
								<k-btn-toggle dense active-class="k-toggle-btn-active-class" class="k-toggle-btn" v-model="frameworks_or_resources_toggle" mandatory aria-label="Choose frameworks or resources view">
									<k-btn small light value="frameworks">Frameworks</k-btn>
									<k-btn small light value="resources">Resources</k-btn>
								</k-btn-toggle>
							</div>
						</div>

						<k-list-item v-if="site_config.framework_update_report_available" v-show="!($vuetify.breakpoint.xs||$vuetify.breakpoint.sm)" tag="button" type="button" class="k-nav-menu-item" @click="show_framework_update_report('load_all')"><k-list-item-icon><k-icon small color="orange darken-4">fas fa-bolt-lightning</k-icon></k-list-item-icon><k-list-item-title>Framework Update Report</k-list-item-title></k-list-item>

						<k-list-item v-for="(link, index) in burger_links" :key="index" tag="a" class="k-nav-menu-item" :href="link.url" target="_case_front" rel="noopener noreferrer"><k-list-item-icon><k-icon small>fas fa-info-circle</k-icon></k-list-item-icon><k-list-item-title v-html="link.text"></k-list-item-title></k-list-item>

						<k-menu v-model="case_links_menu_open" accessible-popover accessible-label="CASE Links" :parent-menu-active="nav_menu_open" content-id="case-links-menu-panel" offset-x left :open-on-hover="false" style="display: block;">
							<template v-slot:activator="{on, attrs}"><k-list-item v-on="on" v-bind="attrs" tag="button" type="button" class="k-nav-menu-item k-nav-menu-submenu-trigger">
								<k-list-item-icon><k-icon small>fas fa-project-diagram</k-icon></k-list-item-icon><k-list-item-title>CASE<sup>®</sup> Links</k-list-item-title>
								<k-list-item-action class="justify-end"><k-icon small aria-hidden="true">fas fa-chevron-right</k-icon></k-list-item-action>
							</k-list-item></template>

							<k-list id="case-links-menu-panel" dense tabindex="-1" aria-label="CASE Links">
								<k-list-item tag="a" class="k-nav-menu-item" href="https://www.imsglobal.org/activity/case" target="_case_front" rel="noopener noreferrer"><k-list-item-icon><k-icon small>fas fa-info-circle</k-icon></k-list-item-icon><k-list-item-title>1EdTech CASE<sup>®</sup> Front Page</k-list-item-title></k-list-item>
								<k-list-item tag="a" class="k-nav-menu-item" href="https://www.imsglobal.org/spec/CASE/v1p1/impl" target="_case_spec" rel="noopener noreferrer"><k-list-item-icon><k-icon small>fas fa-info-circle</k-icon></k-list-item-icon><k-list-item-title>1EdTech CASE<sup>®</sup> 1.1 Best Practice and Implementation Guide</k-list-item-title></k-list-item>
								<k-list-item tag="a" class="k-nav-menu-item" href="https://www.imsglobal.org/sites/default/files/spec/case/v1p1/information_model/caseservicev1p1_infomodelv1p0.html" target="_case_spec" rel="noopener noreferrer"><k-list-item-icon><k-icon small>fas fa-info-circle</k-icon></k-list-item-icon><k-list-item-title>1EdTech CASE<sup>®</sup> 1.1 Spec (Information Model)</k-list-item-title></k-list-item>
								<k-list-item tag="a" class="k-nav-menu-item" href="https://www.imsglobal.org/sites/default/files/spec/case/v1p1/rest_binding/caseservicev1p1_restbindv1p0.html" target="_case_spec" rel="noopener noreferrer"><k-list-item-icon><k-icon small>fas fa-info-circle</k-icon></k-list-item-icon><k-list-item-title>1EdTech CASE<sup>®</sup> 1.1 Spec (REST API)</k-list-item-title></k-list-item>
								<!-- link to casenetwork everywhere *except* case network-->
								<k-list-item v-show="show_registry_link" tag="a" class="k-nav-menu-item" :href="site_config.case_registry_url" target="_casenetwork" rel="noopener noreferrer"><k-list-item-icon><k-icon small>fas fa-map</k-icon></k-list-item-icon><k-list-item-title>{{site_config.case_registry_name}}</k-list-item-title></k-list-item>
							</k-list>
						</k-menu>

						<!-- <k-list-item @click="single_color_scheme_on=!single_color_scheme_on"><k-list-item-icon><k-icon small>fas fa-palette</k-icon></k-list-item-icon><k-list-item-title>Use {{single_color_scheme_on?'multi':'single'}}-color framework scheme</k-list-item-title></k-list-item> -->

						<!-- <k-list-item v-if="!$vuetify.breakpoint.xs&&!$vuetify.breakpoint.sm" @click="toggle_google_translate"><k-list-item-icon><k-icon small>fas fa-language</k-icon></k-list-item-icon><k-list-item-title><div class="d-flex align-center">Toggle Google Translate</div></k-list-item-title></k-list-item> -->

						<v-divider/>
						<div v-if="is_granted('super')">
							<k-list-item tag="button" type="button" class="k-nav-menu-item" @click="show_user_admin_tool=true"><k-list-item-icon><k-icon small color="red">fas fa-users</k-icon></k-list-item-icon><k-list-item-title class="red--text text--darken-3">Manage Users</k-list-item-title></k-list-item>
							<k-list-item v-if="framework_categories.length" tag="button" type="button" class="k-nav-menu-item" @click="show_category_admin_tool=true"><k-list-item-icon><k-icon small color="red">fas fa-layer-group</k-icon></k-list-item-icon><k-list-item-title class="red--text text--darken-3">Manage Framework Categories</k-list-item-title></k-list-item>
							<k-list-item tag="button" type="button" class="k-nav-menu-item" @click="show_framework_access_report=true"><k-list-item-icon><k-icon small color="red">fas fa-info-circle</k-icon></k-list-item-icon><k-list-item-title class="red--text text--darken-3">Framework Access Report</k-list-item-title></k-list-item>
							<v-divider/>
						</div>
						<div v-if="show_custom_export_menu">
							<k-list-item
								tag="button"
								type="button"
								class="k-nav-menu-item"
								@click="open_custom_export_dialog"
							>
								<k-list-item-icon>
									<k-icon small color="red">fas fa-file-arrow-down</k-icon>
								</k-list-item-icon>
								<k-list-item-title class="red--text text--darken-3">Generate Custom Export</k-list-item-title>
							</k-list-item>
							<v-divider/>
						</div>

						<div class="k-signed-in-as-menu-item" v-if="signed_in" v-show="$vuetify.breakpoint.xs||$vuetify.breakpoint.sm">Signed in as <b>{{user_info.first_name}} {{user_info.last_name}}</b></div>
						<k-list-item v-if="!signed_in" v-show="$vuetify.breakpoint.xs||$vuetify.breakpoint.sm" tag="button" type="button" class="k-nav-menu-item" @click="sign_in"><k-list-item-icon><k-icon small>fas fa-sign-in-alt</k-icon></k-list-item-icon><k-list-item-title>Sign In</k-list-item-title></k-list-item>

						<k-list-item v-if="signed_in&&site_config.enable_framework_notifications=='true'" tag="button" type="button" class="k-nav-menu-item" @click="show_user_prefs=!show_user_prefs"><k-list-item-icon><k-icon small>fas fa-bolt</k-icon></k-list-item-icon><k-list-item-title>Framework Notification Preferences</k-list-item-title></k-list-item>

						<!-- cgrt login only on casenetwork-->
						<k-list-item v-show="signed_in&&$store.state.use_auth0_login" tag="button" type="button" class="k-nav-menu-item" @click="open_cgrt"><k-list-item-icon><k-icon small>fas fa-stream</k-icon></k-list-item-icon><k-list-item-title class="k-plain-link">Rosetta GUID Translator Tool</k-list-item-title></k-list-item>

						<k-list-item v-if="signed_in&&!$store.state.use_oidc_login&&!$store.state.use_auth0_login" tag="button" type="button" class="k-nav-menu-item" @click="change_password"><k-list-item-icon><k-icon small>fas fa-key</k-icon></k-list-item-icon><k-list-item-title>Change Password</k-list-item-title></k-list-item>
						<k-list-item v-if="signed_in" tag="button" type="button" class="k-nav-menu-item" @click="sign_out"><k-list-item-icon><k-icon small>fas fa-sign-out-alt</k-icon></k-list-item-icon><k-list-item-title>Sign Out</k-list-item-title></k-list-item>

						<v-divider/>
						<div class="k-nav-menu-footer text-center pr-0" role="note"><div class="d-flex align-center mt-1 mb-2">
							<div>
								<div class="mt-0" style="font-size:18px" translate="no"><b id="version-number" :data-version-number="$store.state.app_version" class="grey--text text--darken-1">Standards Satchel v{{$store.state.app_version}}</b></div>
								<div class="mt-2" style="font-size:14px" translate="no">
									&copy;2026 <a href="https://commongoodlt.com" target="_commongood" rel="noopener noreferrer">Common Good Learning Tools</a>
								</div>
								<div class="mt-0" v-if="site_config.terms_of_use_url||site_config.copyright_org.name">
									<span v-if="site_config.copyright_org.name"> and <a :href="site_config.copyright_org.url" target="_copyright_org" rel="noopener noreferrer">{{site_config.copyright_org.name}}</a></span>
									<k-btn v-if="site_config.terms_of_use_url&&site_config.terms_of_use_url=='satchel'" class="ml-4 mt-2" x-small color="secondary" @click="satchel_tos_showing=true" target="_terms_of_use"><b>Terms of Service</b></k-btn>
									<k-btn v-if="site_config.terms_of_use_url&&site_config.terms_of_use_url!='satchel'" class="ml-4 mt-2" x-small color="secondary" :href="site_config.terms_of_use_url" target="_terms_of_use"><b>Terms of Use</b></k-btn>
								</div>
							</div>
							<div>
								<k-tooltip bottom><template v-slot:activator="{on}"><a v-on="on" class="k-nav-menu-award-link" href="https://www.1edtech.org/li/awards/2023" target="_blank" rel="noopener noreferrer"><img src="/images/learning_impact.svg" style="width:72px;margin:4px 4px 0 8px;" alt="1EdTech Learning Impact Award logo"></a></template><div class="text-center">SuitCASE, Georgia’s implementation of Satchel,<br>won a 2023 1EdTech Learning Impact Award</div></k-tooltip>
							</div>
						</div></div>
					</k-list>
				</k-menu>
			</div>
		</v-app-bar>

		<!-- google translate element is rendered here for cureum_standards_tabbed mode -->
		<div v-if="cureum_standards_tabbed" style="position:absolute; right:12px; bottom:4px; z-index:100" class="d-flex align-center mr-3" :style="(gt_enabled&&!$vuetify.breakpoint.xs&&!$vuetify.breakpoint.sm)?'opacity:1':'opacity:0'">
			<div id="google_translate_element_wrapper"><div id="google_translate_element"></div></div>
			<k-btn v-if="gt_restore_btn_available" x-small outlined class="ml-1 k-tight-btn" color="#333" @click.stop="restore_to_original_language">Restore To Original</k-btn>
		</div>

		<v-main id="main-content" role="main" class="k-content" v-if="app_initialized">
			<router-view :key="router_key"></router-view>

			<!-- iframe used for signout hack -->
			<iframe style="display:none" name="sign_out_window"></iframe>
		</v-main>
		<SignInDialog v-if="show_sign_in_dialog" @dialog_cancel="show_sign_in_dialog=false" />
		<UserPrefs v-if="show_user_prefs" @dialog_cancel="show_user_prefs=false" />
		<AdminUsers v-if="show_user_admin_tool" @dialog_cancel="show_user_admin_tool=false" />
		<AdminFrameworkCategories v-if="show_category_admin_tool" @dialog_cancel="show_category_admin_tool=false" />
		<FrameworkAccessReport v-if="show_framework_access_report" @dialog_cancel="show_framework_access_report=false" />
		<CustomExportDialog
			v-if="show_custom_export_dialog"
			@dialog_cancel="close_custom_export_dialog"
		/>
		<UpdateReport
			ref="framework_update_report"
			v-if="framework_update_report_showing"
			@dialog_cancel="framework_update_report_showing=false"
			:load_all="load_all_framework_updates"
			:restore-focus-element="framework_update_report_focus_origin"
		/>
		<FrameworkSwitcherDialog v-if="framework_switcher_showing" @dialog_cancel="framework_switcher_showing=false" />
		<SVGLines ref="svg_lines" />
		<div v-show="saved_indicator_showing" class="k-case-tree-saved-indicator" role="status" aria-live="polite"><k-icon small class="mr-2" color="#fff" style="margin-top:-3px">fas fa-check</k-icon>SAVED</div>
		<SatchelInline ref="satchel" />			<!-- for showing actual frameworks -->
		<SatchelInline ref="help_satchel" />	<!-- for showing the Sparkl help wiki framework (rendered using Satchel) -->
		<MathLiveEditor v-if="math_live_editor_original_latex!==null" 
			:original_latex="math_live_editor_original_latex" 
			:edit_alt_text="math_live_editor_edit_alt_text" 
			:original_alt_text="math_live_editor_original_alt_text" 
			@dialog_cancel="math_live_editor_original_latex=null" 
			@mathlive_cancel="math_live_editor_save_fn(null)" 
			@mathlive_save="math_live_editor_save_fn($event)" 
		/>
		<TermsOfService v-if="satchel_tos_showing" @dialog_cancel="satchel_tos_showing=false" />
		<ExchangeRegister v-if="show_exchange_register" @dialog_cancel="show_exchange_register=false" />
		<CommonsRegister v-if="show_commons_register" @dialog_cancel="show_commons_register=false" />
		<ResourceQuickAlign v-if="resource_quick_align_showing"
			:params="resource_quick_align_showing"
			@dialog_cancel="resource_quick_align_showing=false" />
		<div id='rqa_dialog_container'></div> <!-- the ResourceQuickAlign UI will be rendered into this container; this allows us to control z-indexes properly -->
	</v-app>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import SignInDialog from '@/components/login/SignInDialog'
import AdminUsers from '@/components/admin/AdminUsers'
import AdminFrameworkCategories from '@/components/admin/AdminFrameworkCategories'
import FrameworkAccessReport from '@/components/admin/FrameworkAccessReport'
import CustomExportDialog from '@/components/admin/CustomExportDialog'
import UpdateReport from '@/components/admin/UpdateReport'
import SVGLines from '@/components/SVGLines/SVGLines'
import AppShortcutsMixin from '@/js/AppShortcutsMixin.js'
import PostMessageMixin from '@/js/PostMessageMixin'
import HelpMixin from '@/js/HelpMixin'
import FrameworkSwitcherDialog from '@/components/frameworks/FrameworkSwitcherDialog'
import SatchelInline from './components/utilities/SatchelInline'
import UserPrefs from './components/admin/UserPrefs'
import MathLiveEditor from './components/mathlive/MathLiveEditor'
import TermsOfService from '@/components/admin/TermsOfService'
import ExchangeRegister from '@/components/admin/ExchangeRegister'
import CommonsRegister from '@/components/admin/CommonsRegister'
import ResourceQuickAlign from '@/components//resources/ResourceQuickAlign'

export default {
	name: 'App',
	components: {
		SignInDialog,
		AdminUsers,
		AdminFrameworkCategories,
		SVGLines,
		FrameworkAccessReport,
		CustomExportDialog,
		UpdateReport,
		FrameworkSwitcherDialog,
		SatchelInline,
		UserPrefs,
		MathLiveEditor,
		TermsOfService,
		ExchangeRegister,
		CommonsRegister,
		ResourceQuickAlign,
	},
	mixins: [AppShortcutsMixin, PostMessageMixin, HelpMixin,],
	data() { return {
		framework_list_component: null,
		case_tree_component: null,
		loading_error: '',
		show_sign_in_dialog: false,
		show_user_prefs: false,
		show_user_admin_tool: false,
		show_category_admin_tool: false,
		show_framework_access_report: false,
		show_custom_export_dialog: false,
		framework_update_report_showing: false,
		framework_update_report_focus_origin: null,
		framework_switcher_showing: false,
		saved_indicator_showing: false,

		bp_requested_in_url: false,

		gt_restore_btn_available: false,

		math_live_editor_original_latex: null,
		math_live_editor_edit_alt_text: false,
		math_live_editor_original_alt_text: '',
		math_live_editor_save_fn: null,

		satchel_tos_showing: false,
		show_exchange_register: false,
		show_commons_register: false,

		resource_quick_align_showing: false,

		ping_timeout: null,
		ping_timeout_time: 60 * 1000 * 10,	// every 10 minutes
		translate_widget_should_show: false,

		load_all_framework_updates: false,
		nav_menu_open: false,
		case_links_menu_open: false
	}},
	computed: {
		...mapState(['app_initialized', 'user_info', 'framework_records', 'framework_categories', 'site_config', 'embedded_mode', 'cureum_standards_tabbed', 'frameworks_accessed']),
		...mapGetters(['signed_in', 'open_mirrors_in_satchel', 'instance_code', 'category_access']),
		show_custom_export_menu() {
			if (!this.signed_in) return false
			if (this.user_info?.system_role !== 'admin') return false
			return Object.keys(this.site_config?.custom_exports || {}).length > 0
		},
		show_resources_toggle() {
			// currently showing this toggle if site_config.resource_alignment_enabled is 'yes' AND the user has (at least) system reviewer rights
			return (this.site_config.resource_alignment_enabled == 'yes' && this.is_granted('resources', 'view_sets'))
			// limit the toggle control for showing the resource alignment interface to certain people for now (we'll expand later)
			if (['pepper@commongoodlt.com', 'mathew@commongoodlt.com', 'sunil.williams.4@gmail.com', 'artfishal@gmail.com'].includes(this.user_info.email)) return true
			return false
		},
		is_resource_route() {
			return ['resource_set_list', 'resource_set', 'resource_edit'].includes(this.$route?.name)
		},
		frameworks_or_resources_toggle: {
			get() { 
				if (!this.show_resources_toggle) return 'frameworks'
				return this.$store.state.lst.frameworks_or_resources_toggle 
			},
			set(val) { 
				this.$store.commit('lst_set', ['frameworks_or_resources_toggle', val]) 
				if (this.frameworks_or_resources_toggle == 'resources') this.go_to_route('resources')
				else this.go_to_route('')
			}
		},
		router_key() {
			let path = this.$route.fullPath
			// note: we do something fancy with this in henryconnects
		},
		single_color_scheme_on: {
			get() { return this.$store.state.lst.single_color_scheme_on },
			set(val) { this.$store.commit('lst_set', ['single_color_scheme_on', val]) }
		},
		gt_enabled: {
			get() { 
				// currently we will always show the google translate option; this could be re-enabled if we want to hide it for some reason
				return true
				return this.$store.state.lst.gt_enabled 
			},
			set(val) { this.$store.commit('lst_set', ['gt_enabled', val]) }
		},	
		agency_logo_img_src() {
			if (!this.site_config.agency_logo) return ''
			return this.site_config.agency_logo
		},
		show_index_agency_title_button() {
			if (this.embedded_mode || this.cureum_standards_tabbed) return false
			if (this.is_resource_route) return false
			if (this.framework_list_component?.case_tree_lsdoc_identifier) return false
			return !!(this.site_config.agency_name_for_banner || this.site_config.agency_name)
		},
		open_agency_label() {
			const agency_name = this.site_config.agency_name_for_banner || this.site_config.agency_name || 'agency site'
			return `Open ${agency_name}`
		},
		app_name_for_banner() {
			if (!empty(this.site_config.app_name_for_banner)) return this.site_config.app_name_for_banner
			return this.site_config.app_name
		},
		app_name() { return this.site_config.app_name },
		burger_links() { return this.site_config.burger_links },
		show_app_name_with_logo() { return this.site_config.show_app_name_with_logo },
		show_registry_link() {
			if (this.instance_code == 'rosetta_exchange') return false
			// if (window.location.toString().includes('localhost')) return false
			return true
		},
	},
	watch: {
		'$route.name':{immediate: true, handler(val) {
			this.syncDocumentLanguage()
			this.$nextTick(x=>{
				if (['framework', 'framework_item', 'framework_item_with_key'].find(x=>x==this.$route.name)) {
					if (this.$store.state.lst.viewer_mode == 'tiles') {
						vapp.set_current_app_help_doc('tileview')
					} else if (this.$store.state.lst.viewer_mode == 'table') {
						if (this.$store.state.lst.viewer_table_mode == 'items') {
							vapp.set_current_app_help_doc('tableitemsview')
						} else {
							vapp.set_current_app_help_doc('tableassociationsview')
						}
					} else {
						vapp.set_current_app_help_doc('treeview')
					}
					//show google translate widget when entering a framework
					const mode_is_tree = this.$store.state.lst.viewer_mode === 'tree'
					const has_case_tree = !!this.case_tree_component
					if (mode_is_tree && has_case_tree) {
						this.translate_widget_should_show = true
						setTimeout(() => {
							$('.goog-te-gadget').show()
						}, 100)
					}
				} else {
					vapp.set_current_app_help_doc('framework_index', 'hide')
					// hide google translate widget when leaving framework route
					this.translate_widget_should_show = false
					setTimeout(() => {
						$('.goog-te-gadget').hide()
					}, 100)
				}
			})
		}},
		'$store.state.lst.viewer_mode': {
			handler(new_mode, old_mode) {
				this.$nextTick(() => {
					// Check conditions for google translate visibility
					const on_framework_route = ['framework', 'framework_item', 'framework_item_with_key'].includes(this.$route.name)
					const mode_is_tree = new_mode === 'tree'
					const has_case_tree = !!this.case_tree_component
					const should_show = on_framework_route && mode_is_tree && has_case_tree

					this.translate_widget_should_show = should_show

					// Show/hide Google Translate widget based on mode
					setTimeout(() => {
						if (mode_is_tree) {
							$('.goog-te-gadget').show()
						} else {
							$('.goog-te-gadget').hide()
						}
					}, 100)
				
					// Initialize only if not already initialized
					if (should_show && !this.google_translate_initialized) {
						this.$nextTick(() => {
							if ($('#google_translate_element').length > 0) {
								this.initialize_google_translate()
							}
						})
					}
				})
			}		
		},
		case_tree_component: {
			handler(new_val, old_val) {
				// Only initialize Google Translate when case_tree_component becomes available
				if (new_val && !this.google_translate_initialized) {
					const on_framework_route = ['framework', 'framework_item', 'framework_item_with_key'].includes(this.$route.name)
					const mode_is_tree = this.$store.state.lst.viewer_mode === 'tree'

					if (on_framework_route && mode_is_tree) {
						this.$nextTick(() => {
							if ($('#google_translate_element').length > 0) {
								$('#google_translate_element').empty()
								this.initialize_google_translate()
							}
						})
					}
				}
			}
		},

		$route: {
			immediate: true,
			async handler(to) {
				this.syncDocumentLanguage()
				const metaTitle = to?.meta?.title
				if (!metaTitle) return

				try {
					const fetchedTitle = typeof metaTitle === 'function' ? await metaTitle.call(this, to) : metaTitle
					const isFrameworkList = to.name === 'framework_list'
					document.title = isFrameworkList ? `${this.app_name}: ${fetchedTitle}` : fetchedTitle
				} catch {
					document.title = this.app_name
				}
			},
		},
		nav_menu_open(is_open) {
			if (!is_open) this.case_links_menu_open = false
		},
	},
	created() {
		this.cn2_redirect()

		// we could call MathLive.renderMathInDocument here, before we even show anything. This injects the styles into the dom, so that when we later inject mathml into the dom, it will render properly
		// MathLive.renderMathInDocument()
		// instead, for now at least, we have a hard-coded version of mathlive-core that we inject here, so that we can also inject this in PrintItems
		U.inject_mathlive_styles()

		console.log(sr('\nStandards Satchel v$1, ©2025 Common Good Learning Tools, LLC\n\n', this.$store.state.app_version), window.location.toString())
		window.vapp = this

		// set up site_config, which is brought in via a special php file included in index.html so we get it right away
		this.$store.commit('write_site_config')

		// check_session as quickly as possible
		this.check_session()
	},
	mounted() {
		this.initialize_app()
		this.syncDocumentLanguage()

		//set document title on initial load
		this.$nextTick(() => {
			const metaTitle = this.$route?.meta?.title
			if (metaTitle) {
				Promise.resolve(
					typeof metaTitle === 'function' ? metaTitle.call(this, this.$route) : metaTitle
				)
					.then(resolved => {
						const isFrameworkList = this.$route.name === 'framework_list'
						document.title = isFrameworkList ? `${this.app_name}: ${resolved}` : resolved
					})
					.catch(() => {
						document.title = this.app_name
					})
			} else {
				//if there is no meta title defined
				document.title = this.app_name
			}
		})
	},
	methods: {
		syncDocumentLanguage() {
			document.documentElement.lang = 'en'
		},
		open_custom_export_dialog() {
			this.show_custom_export_dialog = true
		},
		close_custom_export_dialog() {
			this.show_custom_export_dialog = false
		},
		initialize_app(payload) {
			if (empty(payload)) payload = {}

			// AppShortcutsMixin
			this.initialize_shortcuts()

			// get search params from url string
			let params = (new URL(document.location)).searchParams
			
			// embedded mode
			if (params.get('embedded') != undefined) {
				console.log('--------------------- embedded mode')
				this.$store.commit('set', ['embedded_mode', true])

				// initialize postMessages
				this.pm_initialize()
			}

			// cureum_standards_tabbed mode
			if (params.get('cureum_standards_tabbed') != undefined) {
				console.log('--------------------- cureum_standards_tabbed')
				this.$store.commit('set', ['cureum_standards_tabbed', true])

				// initialize postMessages
				this.pm_initialize()
			}

			// if url search string includes 'assoc', make sure associations are showing
			if (params.get('assoc') != undefined) {
				this.$store.commit('lst_set', ['show_associations', true])
			} else if (this.embedded_mode) {
				// also always show associations (at least at the start) for embedded mode
				this.$store.commit('lst_set', ['show_associations', true])
			}

			// if url search string includes 'help=xxx', show the specified help document, with iframe shown in max view
			// PW 8/10/2025: see the note in CASEItemTile
			if (params.get('help') != undefined) {
				console.warn('help')
				setTimeout(x=>{
					this.show_help(params.get('help'), 'large')
				}, 50)
			}
			
			// if url search string includes 'track_changes', that's the filename of an archive to track changes from
			if (params.get('track_changes') != undefined) {
				// the url has to also have the framework identifier; extract that and save the given filename to lst
				if (window.location.toString().search(/^.*?\/([a-f0-9-]{36})/) > -1) {
					let lsdoc_identifier = RegExp.$1
					if (U.is_uuid(lsdoc_identifier)) {
						let o = {}
						let s = this.$store.state.lst.track_changes_fn
						if (s) o = JSON.parse(s)
						o[lsdoc_identifier] = {
							fn: params.get('track_changes')
						}
						this.$store.commit('lst_set', ['track_changes_fn', JSON.stringify(o)])

						// if search string includes track_changes_fields, apply them
						if (params.get('track_changes_fields') != undefined) {
							this.$store.commit('lst_set', ['track_changes_fields', JSON.parse(params.get('track_changes_fields'))])
						}
						
						// if search string has 'sbshi', that's an indicator that the user wants to view the side-by-side display, starting at that identifier
						if (params.get('sbshi') != undefined) {
							this.$store.commit('lst_set_hash', ['side_by_side_editor_head_identifier', lsdoc_identifier, params.get('sbshi')])
						}
					}
				}
			}

			// if url search string includes 'bp', we're forcing best practices functionality to be fully available
			if (params.get('bp') != undefined) {
				// set bp_requested_in_url to true (this will be set to false once we deal with it, in FrameworkList for a category or CASEFrameworkViewer for a framework)
				this.bp_requested_in_url = true

				// set site_config.bp_summary_policy and bp_full_report_policy to 'always'
				this.site_config.bp_summary_policy = 'always'
				this.site_config.bp_full_report_policy = 'always'
			}

			// token login
			if (params.get('email') != undefined && params.get('token') != undefined) {
				payload.email = params.get('email')
				payload.token = params.get('token')
			}

			// sso from cglt application
			if (params.get('remote_sessid') != undefined && params.get('src_app') != undefined) {
				payload.remote_sessid = params.get('remote_sessid')
				payload.src_app = params.get('src_app')
				//console.log('incoming remote sessid from ' + payload.src_app  + ': ' + payload.remote_sessid)
				
				// clear sso params (if for some reason we stop clearing below)
				//U.clear_location_search()
			}

			// if we got '?start=xxx' in the url, save 'xxx' to state.start_string and send to the initialize_app service; initialize_app and CASEFrameworkViewer will handle what to do with it
			if (params.get('start') != undefined) {
				this.$store.commit('set', ['start_string', params.get('start')])
				if (window.location.href.search(/[0123456789abcdef]{8}-[0123456789abcdef]{4}-[0123456789abcdef]{4}-[0123456789abcdef]{4}-[0123456789abcdef]{12}/) == -1) {
					payload.start_string = params.get('start')
				}
			}

			// clear search string?
			U.clear_location_search()

			return this.$store.dispatch('initialize_app', payload).then((token_result)=>{
				// initialize, and possibly signin, successful
				// set show_sign_in_dialog to false in case the user just signed in
				this.show_sign_in_dialog = false

				// if we just attempted a token signin...
				if (token_result) {
					// for token errors, we just inform the user of the error and proceed with initialization
					if (token_result != 'ok') {
						console.log(token_result)
						let msg = 'The one-time sign-in link you clicked did not work'
						if (token_result == 'token_expired') msg += ', because the link has expired'
						else if (token_result == 'token_not_found') msg += ', possibly because the link was already used once'
						else if (token_result == 'head_request') msg += ' (bad request type)'	// this should never happen in the real world
						msg += '.'
						// open the sign in dialog after they dismiss the error message
						vapp.$alert({title:'<span class="red--text text--darken-2">Sign-In Link Error</span>', text:msg}).then(x=>vapp.sign_in())
					} else {
						// else offer to let the user change their password
						let msg = 'You have been signed in by the one-time link you clicked. Would you like to change your ' + this.app_name + ' password at this time?'
						// Confirmation with property overrides
						this.$confirm({
							text: msg,
							acceptText: 'Change Password',
							cancelText: 'No thank you',
							dialogMaxWidth: 600,
						}).then(y => {
							this.change_password()
						}).catch(n=>{console.log(n)}).finally(f=>{
							// regardless of which option is chosen, call clear_login_token service to clear the login token now
							U.ajax('clear_login_token', {email:payload.email, token:payload.token})
						})
					}
				}
				// http://localhost:6051/?email=xxx&token=yyy

				// if user just signed in, start pinging normally
				// else user may have reloaded page, ping w/no_signout
				if (payload.hasOwnProperty('password') || token_result == 'ok') vapp.ping()
				else vapp.ping('no_signout')

				// if the user tried to go directly to a private framework and needed to sign in, they'd be back here...
				if (this.case_tree_component) {
					// so call refresh_lsdoc on the case_tree_component to show the framework
					this.case_tree_component.refresh_lsdoc()
				}

			}).catch((result)=>{
				// if login_error is empty, alert here; otherwise the signin window should be open and showing the error
				if (empty(this.$store.state.login_error)) {
					this.$alert('An error occurred when attempting to initialize the application. Please try refreshing your browser window.')
				}
			})
		},

		show_saved_indicator() { 
			// if we're already showing the saved indicator, cancel the timeout to hide it
			clearTimeout(this.show_saved_indicator_timeout)
			this.saved_indicator_showing = true
			this.show_saved_indicator_timeout = setTimeout(x=>this.saved_indicator_showing = false, 2000)
		},

		show_framework_switcher() { this.framework_switcher_showing = true },
		hide_framework_switcher() { this.framework_switcher_showing = false },
		open_agency_url() {
			// Keep the agency link in the banner on index routes so skip-to-main lands after it.
			if (this.site_config.free_patch == 'yes') {
				const url = document.location.toString().replace(/\/\/\w+\./, '//')
				window.open(url)
				return
			}

			window.open(this.site_config.agency_url)
		},

		go_to_route(new_route, event) {
			if (!empty(event) && !empty(event.target)) $(event.target).closest('button').blur()

			if (empty(new_route)) {
				// TEMP: if we're viewing a rosetta set that is using a CASE framework, show frameworks
				if (this.resource_set_component?.is_case_resource_set) {
					new_route = 'frameworks'
				} else {
					// else choose the current toggle button value (we will probably get rid of the toggle button once we migrate all sets to frameworks)
					new_route = this.frameworks_or_resources_toggle	// 'resources' or 'frameworks'
				}
			}

			new_route = '/' + new_route
			if (this.$route.path == new_route) return

			this.$router.push({ path: new_route + window.location.search })
		},

		go_to_wiki_link(wiki_doc_identifier) {
			// in wiki mode, links from one wikidoc to another wikidoc will call this fn with the identifier of the doc to go to
			let route = `${this.case_tree_component.lsdoc_identifier}/${wiki_doc_identifier}`
			this.go_to_route(route)
		},

		// this fn can be used by other components that need to open a framework, then execute some other fn, taking into account the fact that the framework might or might not already be showing
		open_framework_then(framework_identifier, viewer_post_load_execute_fn) {
			// if the given framework is already showing, just execute the provided fn right away
			if (this.case_tree_component && this.case_tree_component.lsdoc_identifier == framework_identifier && window.location.pathname.includes(framework_identifier)) {
				if (viewer_post_load_execute_fn) setTimeout(()=>viewer_post_load_execute_fn())
			} else {
				// else stash the fn in store, then open the framework; then the fn will be executed in CASEFrameworkViewer.vue->initialize_tree
				if (viewer_post_load_execute_fn) this.$store.commit('set', ['viewer_post_load_execute_fn', viewer_post_load_execute_fn])

				// if a different framework was loaded previously, we have to first remove the CASEFrameworkViewer component, then re-open it a tick later, to force the new framework to load
				if (this.case_tree_component?.hide_tree) {
					this.case_tree_component.hide_tree()
					setTimeout(()=>{
						this.framework_list_component.view_framework([framework_identifier, framework_identifier])
					}, 10)

				} else {
					// else we can just tell framework_list_component to load the framework now
					this.framework_list_component.view_framework([framework_identifier, framework_identifier])
				}
				// this.go_to_route(`${framework_identifier}/${framework_identifier}`)
			}
		},

		// this can be called to determine if a case tree component is open and is currently visible on the screen
		case_tree_component_is_showing() {
			return !!$(this.case_tree_component?.$el).is(':visible');
		},

		is_granted(verb, noun) {
			let system_role = this.user_info.system_role
			let user_id = this.user_info.user_id

			// general note for below: when in cureum_standards_tabbed mode, we disable admin, editing, and reviewing functionality here

			// users with system_role 'admin' can do anything; call is_granted('super') if only admins are supposed to do what you're checking on
			if (system_role == 'admin' && !this.cureum_standards_tabbed) return true

			// users with system_role 'editor' (and admins) can create new frameworks, via import or from scratch
			if (verb == 'create_new_framework') {
				return (system_role == 'editor' && !this.cureum_standards_tabbed)
			}

			// for viewing the resource alignment interface... (I know we're switching verb and noun here)
			if (verb == 'resources') {
				// to view resource alignments, user must be signed in with admin, editor, or reviewer privileges
				if (noun == 'view_sets') return (system_role == 'reviewer' || system_role == 'editor' || system_role == 'admin')

				// to create new sets, user must be signed in with admin or editor privileges
				if (noun == 'create_sets') return (system_role == 'editor' || system_role == 'admin')

				// note that whether you're allowed to edit alignments is currently controlled directly in ResourceSet
			}

			// for viewing frameworks...
			if (verb == 'view_framework') {
				// get adoptionStatus of framework; noun == framework identifier
				let fr = this.framework_records.find(x=>x.lsdoc_identifier == noun)
				if (empty(fr)) return false	// shouldn't happen

				// anyone can see frameworks whose adoptionStatus doesn't start with 'Private'
				if (!U.framework_is_private(fr)) return true

				// roles editor and admin can see any framework
				if (system_role == 'editor') return true
				if (system_role == 'admin') return true

				// system role reviewer can also see 'Private X' frameworks (meaning anything)
				if (system_role == 'reviewer') return true

				// check to see if this user has been granted editor or reviewer rights to this particular framework
				let ur = fr.ss_framework_data.user_rights[user_id] || 'none'
				if (['reviewer', 'editor', 'admin'].includes(ur)) return true
			}

			// for reviewing frameworks...
			if (verb == 'review_framework' && !this.cureum_standards_tabbed) {
				// system roles editor and reviewer (and admin, which is handled above) can review any framework
				if (system_role == 'editor' || system_role == 'reviewer') return true

				// get user_rights of framework; noun == framework identifier
				let fr = this.framework_records.find(x=>x.lsdoc_identifier == noun)
				if (empty(fr)) return false	// shouldn't happen
				let fr_user_rights = fr.ss_framework_data.user_rights

				// check to see if this user has been granted admin, editor, or reviewer rights to this particular framework
				let ur = fr_user_rights[user_id] || 'none'
				if (ur == 'admin' || ur == 'editor' || ur == 'reviewer') return true

				// note that for most purposes, the 'reviewer' role is just used to allow a user to view a private framework, which is handled above
				// but there are some things (i.e. seeing associations when the associations have been marked as hidden to most people) where we explicitly check the reviewer permission level
			}

			// for editing frameworks...
			if (verb == 'edit_framework' && !this.cureum_standards_tabbed) {
				// system role editor (and admin, which is handled above) can edit any framework
				if (system_role == 'editor') return true

				// get user_rights of framework; noun == framework identifier
				let fr = this.framework_records.find(x=>x.lsdoc_identifier == noun)
				if (empty(fr)) return false	// shouldn't happen
				let fr_user_rights = fr.ss_framework_data.user_rights

				// check to see if this user has been granted admin or editor rights to this particular framework
				let ur = fr_user_rights[user_id] || 'none'
				if (ur == 'admin' || ur == 'editor') return true
			}

			// for administering frameworks...
			if (verb == 'admin_framework' && !this.cureum_standards_tabbed) {
				// system_role admin, which is handled above, can admin any framework

				// get user_rights of framework; noun == framework identifier
				let fr = this.framework_records.find(x=>x.lsdoc_identifier == noun)
				if (empty(fr)) return false	// shouldn't happen
				let fr_user_rights = fr.ss_framework_data.user_rights

				// check to see if this user has been granted admin rights to this particular framework
				if (fr_user_rights[user_id] == 'admin') return true
			}

			return false
		},

		reset_app() {
			// this should be called when a component detects that the user is not authorized for something
			this.go_to_route('')
			this.initialize_app()
		},

		// determine if the user's session is still active; if not, show a message and call the sign out process
		ping(type) {
			// we want to automatically call this fn every ping_timeout_time ms. if it's manually called by something else, we reset the timeout
			clearTimeout(this.ping_timeout)

			let sign_user_out = () => {
				let msg = 'You are not signed in. You may have been automatically signed out due to inactivity.'
				this.$alert({
					text: msg,
				}).finally(f=>{
					this.$store.dispatch('sign_out')
				})
			}

			// use plain-vanilla XMLHttpRequest to call the ping service
			var xhr = new XMLHttpRequest()
			xhr.onreadystatechange = function() {
				if (xhr.readyState === 4) {		// fetch operation is done
					if (xhr.responseText == 'ok') {
						console.log('ping OK')
						// set the timeout to re-call this fn after ping_timeout_time
						vapp.ping_timeout = setTimeout(()=>{ vapp.ping() }, vapp.ping_timeout_time)

					} else {
						if (type != 'no_signout') {
							sign_user_out()
							console.log('ping FAIL (user signed out)')
						} else {
							// don't show sign out if user loading or refreshing page but not logged in
							console.log('ping FAIL (ping w/no_signout flag)')
						}
					}
				}
			}
			xhr.open('GET', '/src/ping.php')
			xhr.send()
		},

		reload_window() {
			// when we need to reload, if we are in embedded or cureum_standards_tabbed mode, we have set the search string to make sure we open back up in that mode
			if (this.embedded_mode) window.location.search = 'embedded'
			else if (this.cureum_standards_tabbed) window.location.search = 'cureum_standards_tabbed'
			// otherwise just use location.reload
			else window.location.reload()
		},

		check_session() {
			// if we're not using OAuth login, we have to pass the session_id back and forth.
			// this code will have no effect if we're NOT using OAuth.

			// when the application first loads after the user has signed in, we should get a session_id in the search string of window.location...
			// if we have 'not_authorized=true', it means OAuth said the user wasn't authorized to sign in (even though they entered proper credentials)

			// TODO: this should only have been needed when we were using 1EdTech's login process; we should be able to delete this block

			if (window.location.search.search(/not_authorized=true/) != -1) {
				// this is currently used for CASE Network only
				this.$alert({title:'Sorry!', text:`You are not authorized for registered access to ${this.site_config.case_registry_name}. Please go to <a href="${this.site_config.case_registry_registration_url}" target="_blank">this webpage</a> to request registered access.<div class="mt-2">In the meantime, you are welcome to browse all frameworks in ${this.site_config.app_name} without signing in.</div>`})

				// look for a pathname stored previously; if not found we'll go to path '/'
				let pathname = U.local_storage_get('satchel_pathname_after_login', '/')

				// clear the stored pathname out if there, then go to the route
				U.local_storage_clear('satchel_pathname_after_login')
				console.log('restoring to pathname ' + pathname)
				this.$router.replace({ path: pathname })

			} else if (window.location.search.search(/session_id=(.*)\b/) == -1) {
				// if we *don't* find a session_id here...

				// look for the session_id in localstorage, where we would have stored it the previous time the user signed in
				U.session_id = U.local_storage_get('satchel_session_id', '')

				// if we still don't have a session_id, the user isn't signed in (which is fine for satchel)

			} else {
				// else we *did* find a session_id in the search string, so...

				// save session_id in U.session_id
				U.session_id = RegExp.$1
				console.log('found session_id: ' + U.session_id)

				// store the session_id in localstorage
				U.local_storage_set('satchel_session_id', U.session_id)

				// look for a pathname stored previously; if not found we'll go to path '/'
				let pathname = U.local_storage_get('satchel_pathname_after_login', '/')

				// clear the stored pathname out if there, then go to the route
				U.local_storage_clear('satchel_pathname_after_login')
				this.$router.replace({ path: pathname })
			}
		},

		sign_in(evt) {
			// if we're using OIDC/Auth0 for login, redirect to a back-end script to initiate the signin process (unless shift is held down)
			if (evt == 'oauth' || ((this.$store.state.use_auth0_login || this.$store.state.use_oidc_login) && !(evt && evt.shiftKey == true))) {
				// before we go, remember the pathname we're trying to get to in localstorage, so we can restore to it when we get back
				U.local_storage_set('satchel_pathname_after_login', window.location.pathname)

				let url
				if (this.$store.state.use_auth0_login) url = '/src/auth/auth0_login.php?route=login' // local testing http://127.0.0.1:8002/src/auth/auth0_login.php?route=login
				else if (this.$store.state.use_oidc_login) url = '/src/oidclogin.php'
				window.document.location.assign(url)

			} else {
				this.show_sign_in_dialog = true
			}
		},

		change_password() {
			this.$prompt({
				title: 'Change Password',
				text: 'Enter the new password you would like to use for your <nobr>' + this.app_name + '</nobr> account:',
				promptType: 'password',
				acceptText: 'Use this password',
			}).then(password => {
				if (!empty(password)) {
					this.$prompt({
						title: 'Confirm New Password',
						text: 'Please confirm the new password you just entered:',
						promptType: 'password',
						acceptText: 'Confirm and Save new password',
					}).then(new_password => {
						if (password != new_password) {
							this.$alert('The two passwords you entered do not match!').then(x=>this.change_password())
							return
						}

						let payload = {
							user_id: this.user_info.user_id,
							password: password,
						}

						U.loading_start()
						U.ajax('change_password', payload, result=>{
							U.loading_stop()
							if (result.status != 'ok') {
								console.log('Error in admin ajax call'); vapp.ping(); return
							}

							this.$alert({title:'Success!', text:'Password changed.'})
						})

					}).catch(n=>{console.log(n)}).finally(f=>{})
				}
			}).catch(n=>{console.log(n)}).finally(f=>{})
		},

		// this is called whenever the user requests an action that allows them to access the data (e.g. download or api) for a framework.
		// we check logic here to determine if the user should be able to take that action; if not, we show an alert and return `true` to signal that the user shouldn't be able to take the action
		signed_in_only(msg, framework_identifier) {
			let app_name = this.site_config.app_name
			let access_restricted = false

			// for satchelalign (including any subdomains)...
			if (this.instance_code == 'rosetta_align') {
				// you must be (viewing a framework) and (have edit rights to that framework) to be able to have full access
				access_restricted = !( $(this.case_tree_component?.$el).is(':visible') && this.case_tree_component.user_can_edit)

			// for satchel commons
			} else if (this.instance_code == 'satchel_commons') {
				// if we're in a subdomain, any available frameworks are available to access the functionality that goes through this function, whether you can edit or not
				if (this.$store.getters.viewing_subdomain) {
					access_restricted = false

				// and if the user has review access or above (at system or framework level), access is not restricted
				} else if (!empty(framework_identifier) && this.is_granted('review_framework', framework_identifier)) {
					access_restricted = false

				} else if (['reviewer', 'editor', 'admin'].includes(this.user_info.system_role)) {
					access_restricted = false

				// else access is restricted
				} else {
					access_restricted = true
				}
				// NOTE: this logic really shouldn't matter at this time (2/2026), because on commons:
				// - If you're viewing a subdomain we should only be showing frameworks for that subdomain's categories
				// - If you're not viewing a subdomain, we should only be showing *any* frameworks iff you've been explicitly granted access to the frameworks

			// for rosetta exchange
			} else if (this.instance_code == 'rosetta_exchange') {
				// if category_access is 'all', or user has system reviewer rights or higher, access is not restricted for anything
				if (this.category_access == 'all' || ['reviewer', 'editor', 'admin'].includes(this.user_info.system_role)) {
					access_restricted = false

				// else if category_access is empty, or we're checking on a general (not framework-specific) thing, access is restricted
				} else if (empty(this.category_access) || empty(framework_identifier)) {
					access_restricted = true

				// else we're checking on a framework-specific function...
				} else {
					// if the user has review access or above for this framework, access is not restricted
					if (this.is_granted('review_framework', framework_identifier)) {
						access_restricted = false

					// else look at category_access
					} else {
						// get the category for the framework
						let fr = this.framework_records.find(x=>x.lsdoc_identifier == framework_identifier)
						let cr = U.parse_framework_category(fr.ss_framework_data.category)

						// if this framework's category is in this.category_access, not restricted
						if (!empty(cr?.map_label) && this.category_access.includes(cr.map_label)) {
							access_restricted = false
						} else {
							// else restricted
							access_restricted = true
						}
					}
				}
			}

			if (access_restricted) {
				if (empty(msg)) msg = 'perform this action'

				if (empty(framework_identifier)) {
					msg = `You must be signed in with registered access to ${app_name} in order to ${msg}.`
				} else {
					msg = `You must be signed in with registered access to this framework in ${app_name} in order to ${msg}.`
				}

				// extra text for Rosetta Exchange
				if (this.instance_code == 'rosetta_exchange') {
					msg += `<div class="my-2">Please click the button below to learn how to REGISTER for ${app_name}. You can also contact <a href="mailto:support@commongoodlt.com">support@commongoodlt.com</a> for more assistance.</div>`
				}

				// for 'rosetta_align' instances, there's no recourse for not being able to do this; for exchange and commons, you can register
				let fn = '$confirm'
				if (this.instance_code == 'rosetta_align') fn = '$alert'

				this[fn]({
					title: 'Access Restricted',
					text: msg,
					acceptText: 'OK ',
					acceptIcon: 'fas fa-check',
					cancelText: 'Register',
					cancelIcon: 'fa-list-check',
					cancelColor: 'green darken-3',
					dialogMaxWidth: 600,
				}).then(y => {
					
				}).catch(n=>{
					if (this.instance_code == 'rosetta_exchange') {
						this.show_exchange_register = true
					} else {
						this.show_commons_register = true
					}
				}).finally(f=>{})

				// return true; the caller should then abandon what it was trying to do
				return true
			}
			return false
		},

		record_framework_download(framework_identifier) {
			// if the user is signed in, record the fact that this user (and eventually the user's "organization") has accessed this framework
			if (this.user_info.user_id) {
				U.ajax('record_framework_download', {user_id:this.user_info.user_id, framework_identifier:framework_identifier}, result=>{
					console.warn('record_framework_download', result)
					// store result.frameworks_accessed in store
					this.$store.commit('set', ['frameworks_accessed', result.frameworks_accessed])
				})
			} else console.warn('not signed in')
		},

		sign_out() {
			this.$store.dispatch('sign_out')
		},

		// open the guid translator, send session_id for sso to cgrt
		open_cgrt() {
			let session_id = U.local_storage_get('satchel_session_id', '')
			let cgrt_ip = this.$store.state.cgrt_ip

			if (empty(session_id)) {
				// this just returns the user's php session_id
				U.ajax('get_sid', {}, result=>{
					if (result.status != 'ok') {
						console.log('Unable to get session_id'); vapp.ping(); return
					}
					window.open(sr('$1/?session_id=$2', cgrt_ip, result.session_id))
				})
			} else {
				window.open(sr('$1/?session_id=$2', cgrt_ip, session_id))
			}	
		},

		// cglt sso login, user must be signed in to source app e.g. ccbo satchel -> inspire
		// the target_app param is configured on server config.php
		cglt_sso(target_app, target_url_suffix) {
			let target_url = `${this.site_config.cglt_sso[target_app]}${target_url_suffix}`
			let src_app = this.site_config.cglt_sso['src_app']

			console.warn(`cglt sso: ${target_url}/?remote_sessid=${U.session_id}&src_app=${src_app}`)
			window.open(`${target_url}/?remote_sessid=${U.session_id}&src_app=${src_app}`, 'alt_cureum')
		},

		show_framework_update_report(flag, archive_val) {
			if (vapp.signed_in_only('view Framework Update Reports')) return

			const nav_menu_button = typeof document !== 'undefined'
				? document.getElementById('nav-bar-menu-button')
				: null
			this.framework_update_report_focus_origin = this.nav_menu_open
				? nav_menu_button
				: document.activeElement


			// if we're currently showing a framework, open to that framework
			let framework_identifier = null
			let report_type = 'last'
			// console.log(flag)
			if (flag === 'load_all') {
				this.load_all_framework_updates = true
			} else {
				this.load_all_framework_updates = false
			}
			if (this.case_tree_component?.lsdoc_identifier) {
				framework_identifier = this.case_tree_component.lsdoc_identifier
				this.$store.commit('lst_set', ['update_report_by_framework_identifier', framework_identifier])
				// if we got an 'archives' flag, show all archives for the framework
				if (flag == 'archives') {
					report_type = 'framework_all_archives'

				// else if flag is framework_archive_compare, show that report; this is called from the bottom banner when we're in track changes mode, so the archive should already be stored in archive_compare_arr
				} else if (flag == 'framework_archive_compare') {
					report_type = 'framework_archive_compare'

				// else if lst.update_report_type is 'update_type', switch to the framework report
				} else if (this.$store.state.lst.update_report_type == 'update_type') {
					report_type = 'framework'
				}	
			}
			if (framework_identifier) {
				setTimeout(()=>this.$refs.framework_update_report.show_framework_report(framework_identifier, report_type), 50)
			}
			this.nav_menu_open = false
			this.case_links_menu_open = false
			this.$nextTick(() => {
				this.framework_update_report_showing = true
			})
		},

		reset_framework_update_report_archives(framework_identifier) {
			this.$store.commit('set', [this.$store.state.framework_archives, framework_identifier, null])
		},

		show_line(line_props) {
			// return the line's uuid, so the caller can kill it if they wish
			return this.$refs.svg_lines.add_line(line_props)
		},

		remove_line(uuid) {
			this.$refs.svg_lines.remove_line(uuid)
		},

		remove_all_lines() {
			this.$refs.svg_lines.remove_all_lines()
		},

		/////////////////////////
		// google translate
		initialize_google_translate() {
			if (this.google_translate_interval) {
				clearInterval(this.google_translate_interval)
				this.google_translate_interval = null
			}

			if (typeof google === 'undefined' || typeof google.translate === 'undefined') {
				setTimeout(() => {
					this.initialize_google_translate()
				}, 100)
				return
			}
			// note that the translate element has to be in the dom and visible; we set its opacity to 0 to hide it until the the user says they want to see it
			U.googleTranslateElementInit()
			this.google_translate_initialized = true

			// once every second...
			this.google_translate_interval = setInterval(x=>{
				let l = U.googleTranslateGetCurrentLanguage()

				// get the "default" language for what's currently being viewed, from site_config ('en' is the default)
				let default_language = this.site_config.default_language
				
				// if we're viewing a document, use its language property if listed
				if (vapp.case_tree_component?.framework_record) {
					if (!empty(vapp.case_tree_component.framework_record.json.CFDocument.language)) {
						default_language = vapp.case_tree_component.framework_record.json.CFDocument.language
					}
				}
				// console.log(`current translation: “${l}”; default language: “${default_language}”`)

				// if the user has explicitly chosen the default language in the Google Translate menu, cancel google translate, because when GT tries to translate english into english (e.g.), wierd things happen (e.g. with latex)
				if (l == default_language) {
					this.restore_to_original_language()
					l = ''
				}

				// set gt_restore_btn_available to true iff we're viewing a translation
				this.gt_restore_btn_available = !empty(l)

				// and if google translate is showing the annoying spinner, hide it. This will likely need to be updated as google translate evolves
				let jq = $('#loom-companion-mv3').next()
				if (jq.find('svg').length > 0) {
					jq.hide()
				}

				U.googleTranslateSyncHiddenControls()
			}, 1000)
		},

		toggle_google_translate_btn(fn) {	// 'show' or 'hide'
			$('#google_translate_element_wrapper')[fn]()
		},

		restore_to_original_language() {
			U.googleTranslateRestoreOriginal()
			this.syncDocumentLanguage()
		},

		toggle_google_translate(val) {
			if (typeof(val) != 'boolean') val = !this.gt_enabled
			this.gt_enabled = val

			// when user chooses to disable, restore to original language, in case they translated
			if (this.gt_enabled == false) {
				this.restore_to_original_language()
			}
		},

		show_math_live_editor(args) {
			// we originally accepted two arguments like so:
			if (arguments.length == 2) {
				this.math_live_editor_original_latex = arguments[0]
				this.math_live_editor_edit_alt_text = false
				this.math_live_editor_original_alt_text = ''
				this.math_live_editor_save_fn = arguments[1]
			
			// starting 1/2025, we use an args object like so:
			} else {
				this.math_live_editor_original_latex = args.original_latex
				this.math_live_editor_edit_alt_text = args.edit_alt_text || false	// default is false
				this.math_live_editor_original_alt_text = args.original_alt_text || ''	// default is empty string
				this.math_live_editor_save_fn = args.save_fn
			}

			// call like this:
			// vapp.show_math_live_editor('\\sqrt{x}', new_latex => { })
		},

		show_headline_dialog(key) {
			this.$alert({
				text: this.site_config[key],
				dialogMaxWidth:600,
			})
		},

		cn2_redirect() {
			let url = window.location.toString()
			// for debugging locally, include ?casenetwork.1edtech.org in the url

			// if we have cn2_redirect in the search string, show the dialog
			if (url.includes('cn2_redirect')) {
				console.warn('cn2_redirect', window.location.search)
				this.$store.commit('set', ['redirected_from_cn2', true])
				this.show_cn2_redirect_dialog(0)

			// else if the url includes 'casenetwork.1edtech.org', redirect
			} else if (url.includes('casenetwork.1edtech.org')) {
				url += (url.includes('?') ? '&' : '?') + 'cn2_redirect'
				// this conditional lets us test this locally
				if (!url.includes('localhost')) {
					url = url.replace(/^http.*?\/\/.*?\/(.*)/, 'https://rosetta.commongoodlt.com/$1')
				}

				// TODO: remove this and rebuild on 2/10/2026 to make redirect start
				// include ?test_redirect to test the redirect
				// if (!url.includes('test_redirect')) return

				console.warn('redirect to ' + url)
				window.location.replace(url)
			}
		},

		show_cn2_redirect_dialog(count) {
			// wait up to 10 seconds for site_config to be loaded
			if (empty(this.site_config.cn2_redirect_message) && count < 100) {
				setTimeout(x=>{
					console.log('waiting for cn2_redirect_message...')
					this.show_cn2_redirect_dialog(count+1)
				}, 100)
				return
			}

			this.$confirm({
				title: 'CASE Network 2 is now Satchel Rosetta Exchange',
				// the dialog message is in site_config so we can easily update it
				text: this.site_config.cn2_redirect_message,
				acceptText: 'OK ',
				acceptIcon: 'fas fa-check',
				cancelText: 'Register',
				cancelIcon: 'fa-list-check',
				cancelColor: 'green darken-3',
				dialogMaxWidth: 760,
			}).then(y => {
			}).catch(n=>{
				this.show_exchange_register = true
			}).finally(f=>{})
		},

		show_resource_quick_align(params) {
			// if params is false, this will close the dialog; otherwise it will send the params to the interface, which will handle them 
			this.resource_quick_align_showing = params
		},

		hide_resource_quick_align(params) {
			vapp.$refs.satchel.execute('hide')
			this.resource_quick_align_showing = false
		},
	}
}
</script>

<style lang="scss">
body, html {
	font-size:18px;
	background-color:#999!important;
}

.k-reset-button {
	background: transparent;
	border: 0;
	padding: 0;
}

html {
	// this hides the otherwise-everpresent scroll bar on the right side of the window, which is never needed in the Satchel app
	overflow:hidden;
}

.v-application {
	// font-family added in index.html via env variable
	background-color:#fff!important;
}

.theme--dark.v-application {
	// background:transparent;
}

.v-btn {
	text-transform: none;
	font-size:16px;
}

.k-app-toolbar {
	// background-color will be added by k-banner-color
}

// .k-toolbar-agency-img-outer and .k-toolbar-agency-img are defined in index.html based on env; this lets us adjust the image and/or app name

.k-toolbar-home-link {
	position: relative;
	display: inline-flex;
	align-items: center;
	min-height: 60px;
	padding-right: 12px;
	border-radius: 6px;
	z-index: 1;
}

.k-toolbar-home-link:focus-visible {
	outline: none;
}

.k-toolbar-home-link:focus-visible.k-toolbar-app-title {
	text-decoration: underline;
	text-underline-offset: 0.14em;
	text-decoration-thickness: 0.09em;
}

.k-toolbar-app-title {
	position:absolute;
	left:0;
	cursor:pointer;
	font-size:28px;
	color:#fff;
	font-weight:bold;
	// padding-left is defined in .eng/index.html
	z-index:2;
}

.k-toolbar-app-logo {
	position:absolute;
	left:165px;
	top:-15px;
}

// this would make it so that a long image (e.g. rosetta exchange) won't push the menu off the right side
.k-toolbar-app-title .k-toolbar-agency-img-outer {
	position:absolute;
	left:0;
	top:0;
}

.k-toolbar-agency-img {
	max-width:100vw;
}

.k-toolbar-index-agency-title {
	position:absolute;
	left:0;
	top:60px;
	z-index:4;
	font-size:18px;
	font-weight:bold;
	line-height:30px;
	padding:0 18px;
	border-radius:0 0 8px 0px;
	max-width:min(620px, calc(100vw - 72px));
	display:inline-block;
	min-height:30px;
	white-space:nowrap;
	overflow:hidden;
	text-overflow:ellipsis;
}

.k-toolbar-index-agency-title:hover,
.k-toolbar-index-agency-title:focus {
	text-decoration:underline;
}

@media (max-width: 600px) {
	.k-toolbar-index-agency-title {
		left: 8px;
		top: 60px;
		font-size: 16px;
		line-height: 26px;
		padding: 0 14px;
		min-height: 26px;
		max-width: calc(100vw - 24px);
	}
}

.k-signed-in-as {
	white-space:nowrap;
	font-size:14px;
}

.k-signed-in-as-menu-item {
	// min-height:30px!important;
	// height:30px!important;
	// padding-top:16px;
	padding: 12px 16px 4px;
	text-align:center;
	font-style: italic;
}

.k-nav-menu-item {
	width: 100%;
	border: 0;
	background: transparent;
	text-align: left;
}

.k-nav-menu-section {
	padding: 10px 16px 6px;
}

.k-nav-menu-footer {
	padding: 8px 16px 12px;
}

.k-nav-menu-award-link {
	display: inline-flex;
	align-items: center;
	border-radius: 10px;
	outline: none;
}

.k-nav-menu-award-link:focus-visible {
	background: rgba(0, 0, 0, 0.04);
	box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.14);
}

.k-toolbar-sparkler-placeholder {
	display:inline-block;
	width:18px;
}

.k-content {
}

.k-case-tree-saved-indicator {
	position:fixed;
	left:8px;
	top:8px;
	z-index:99999999;
	background-color:$v-green-darken-3;
	color:#fff;
	font-weight:bold;
	font-size:18px;
	line-height:18px;
	padding:6px 10px;
	border-radius:8px;
	border:4px solid $v-amber-accent-4;
	transition:all 0.2s;
	opacity:1;
	box-shadow: 0 0 10px rgba(255, 230, 0, 0.8), 0 0 20px rgba(255, 230, 0, 0.6);
}

// Google translate functionality:
// fix the translate menu in the window
#google_translate_element_wrapper { 
	opacity:0.4;

	.goog-te-gadget-simple {
		border-radius:6px;
		padding:4px;
	}
}

#google_translate_element_wrapper:hover {
	opacity:1;
}

// When another language is selected, Google tries to show a bar at the top of the page; hide it
.skiptranslate iframe.skiptranslate {
	display: none !important;
} 

#goog-gt-votingHiddenPane,
iframe[name="votingFrame"] {
	display: none !important;
	visibility: hidden !important;
}

body {
	// google tries to set the top property of body; this has to be overridden
	top: 0px !important; 
}

</style>
